/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";

import "./LandingPagePreview.scss";

const LandingPagePreview = ({ organizationLogoUrl, nameForDisplay, customPolicies }) => {
	const getRules = () => {
		const defaultPolicies = `<ul>
			<li>
				All jobs requested and worked must follow department rules and regulations.
			</li>
			<li>
				Any job request that do not meet the department&#39;s rules and regulations may be denied at
				the discretion of the department.
			</li>
			<li>
				Any changes to job requests have to be submitted in a timely manner.
			</li>
			<li>
				Any electronic invoices sent via RollKall platform must be paid through the platform.
			</li>
			<li>
				All invoices sent from the platform have to be paid in a timely manner, as agreed upon with the department.
			</li>
		</ul>`;

		return (
			<div
				className="custom-policies"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: customPolicies || defaultPolicies }}
			/>
		);
	};

	return (
		<main className="client-landing-page">
			<div className="line" />

			<header className="organization-name text-center width-all margin-top-15 flex flex-justify-content-center flex-align-items-center fadeInLeft">
				<img
					src={organizationLogoUrl || "/images/rk-shield.png"}
					alt="logo"
					width={80}
					height={80}
				/>
				<h1 className="margin-left-15">{nameForDisplay}</h1>
			</header>

			<nav className="text-center fadeInRight">
				<div className="container-fluid">
					<p className="welcome-message navbar-text">
						Welcome to Rollkall&#39;s online job scheduling platform that makes it
						easier for you to&nbsp;
						<span className="hightlight">view</span>,&nbsp;
						<span className="hightlight">request</span> and{" "}
						<span className="hightlight">pay for off duty jobs</span>
					</p>
				</div>
			</nav>

			<div className="flex-1 margin-top-15 fadeInUp">
				<form>
					<div className="container row client-form">
						<aside className="policies col-md-6 margin-bottom-15">
							<h5 className="text-center font-bold margin-bottom-30">
								{nameForDisplay} Policies
							</h5>

							<p className="text-center margin-bottom-30">
								To request and fulfill jobs, you have to agree to the following
								policies:
							</p>

							{getRules()}
						</aside>

						<aside className="account-information col-md-6">
							<h5 className="text-center font-bold margin-bottom-15">
								Please complete the fields below
							</h5>

							<div className="form-group">
								<label htmlFor="companyVenderNameText">Company / Vendor Name</label>
								<input
									type="text"
									id="companyVenderNameText"
									className="form-control"
									placeholder="Company / Vendor Name"
									name="CompanyName"
									disabled="disabled"
								/>
							</div>

							<div className="form-group">
								<label htmlFor="emailText">Email</label>
								<input
									type="email"
									id="emailText"
									className="form-control"
									placeholder="Enter email"
									name="EmailAddress"
									disabled="disabled"
								/>
							</div>
							<div className="form-group">
								<label htmlFor="firstNameText">First Name</label>
								<input
									type="text"
									id="firstNameText"
									className="form-control"
									placeholder="First Name"
									name="FirstName"
									disabled="disabled"
								/>
							</div>
							<div className="form-group">
								<label htmlFor="lastNameText">Last Name</label>
								<input
									type="text"
									id="lastNameText"
									className="form-control"
									placeholder="Last Name"
									name="LastName"
									disabled="disabled"
								/>
							</div>
						</aside>
					</div>
				</form>

				<div className="row margin-bottom-100">
					<div className="col-md-6" />
					<div className="col-md-6 flex flex-direction-column flex-center margin-top-30">
						<div className="form-check">
							<input
								type="checkbox"
								className="form-check-input"
								id="agreeCheck"
								disabled="diabled"
							/>
							<label
								className="form-check-label margin-left-5"
								htmlFor="agreeCheck"
							>
								I have read and agree to the {nameForDisplay} policies
							</label>
						</div>

						<div className="flex flex-center margin-top-30">
							<button
								type="button"
								className="btn btn-primary btn-lg"
								disabled="disabled"
							>
								Create RollKall Account
							</button>
						</div>
					</div>
				</div>
			</div>

			<footer className="text-center">
				<p>
					Questions and Concerns? Please don&#39;t hesitate to get in touch with us at
					&nbsp;
					<a href="mailto:support@rollkall.com">support@rollkall.com</a>
				</p>
				<div className="flex flex-justify-content-center margin-bottom-10">
					<a
						href="https://www.rollkall.com/terms"
						target="_blank"
						rel="noreferrer"
					>
						Terms of Service
					</a>
					&nbsp;
					<a
						href="https://www.rollkall.com/privacy"
						target="_blank"
						rel="noreferrer"
					>
						Primary Policy
					</a>
				</div>
				<p className="powered">
					Powered by RollKall Copyright &#169; {new Date().getFullYear()} All rights
					reserved
				</p>
			</footer>
		</main>
	);
};

LandingPagePreview.propTypes = {
	organizationLogoUrl: PropTypes.string.isRequired,
	nameForDisplay: PropTypes.string.isRequired,
	customPolicies: PropTypes.string.isRequired,
};

LandingPagePreview.defaultProps = {};

export default LandingPagePreview;
